module.exports = __webpack_public_path__ + "img/bgl_3x.d24497d2.png";